module.exports = __webpack_public_path__ + "d570a96d4b909e908685048d88f403af.svg";